import isSearchBoxEmpty from '../selectors/isSearchBoxEmpty';
import loc from 'owa-localize';
import { SearchPlaceholder } from 'owa-locstrings/lib/strings/searchplaceholder.locstring.json';
import { SearchScenarioId } from 'owa-search-next-common';

/**
 * Returns the placeholder and aria label for the search input component.
 * Set the placeholder as the search placeholder, parameter placeholder, or "".
 * Set the aria label as the search or parameter placeholder.
 */
export default function getPlaceholderAndAriaLabel(
    scenarioId: SearchScenarioId,
    searchPlaceHolderText: string
) {
    const placeholderText = searchPlaceHolderText ? searchPlaceHolderText : loc(SearchPlaceholder);

    let searchPlaceholder = placeholderText;

    // Don't show a placeholder if search box isn't empty.
    if (!isSearchBoxEmpty(scenarioId)) {
        searchPlaceholder = '';
    }

    return {
        ariaLabel: placeholderText,
        placeholder: searchPlaceholder,
    };
}
